import { Spinner } from "react-bootstrap";
import { useCourseCounter } from "../hooks";

export const CourseCounter = ({ courseId }) => {
  const { counter, isLoading, isError } = useCourseCounter({ courseId });

  if (isLoading && !counter) {
    return (
      <div className="modern-course-counter-loading">
        <Spinner size="sm" animation="border" />
      </div>
    );
  }

  if (isError || !counter) {
    return <strong className="modern-course-counter-value">—</strong>;
  }

  const totalMinutes = Number(counter.minutes || 0);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return (
    <strong className="modern-course-counter-value">
      {hours > 0 ? `${hours} h ${minutes} min` : `${minutes} min`}
    </strong>
  );
};
